<div
    role="tabpanel"
    [id]="id + '.panel'"
    class="agpr-tab"
    [style.display]="selected && !hidden ? '' : 'none'"
    [attr.aria-labelledby]="id"
>
    <ng-content></ng-content>
</div>
